import { defaultMain } from '@/router/index';
import { myTeamsList, myTeamsEventsRequests } from '@/modules/Team/routes.js';
// import { teams } from '@/modules/Team/routes.js';
import { events, eventsStock, eventAssociations, uiEventsStockDashboard } from '@/modules/Events/routes.js';
import { eventPlan, uiEventPlan } from '@/modules/EventsPlan/routes';
import { analytics } from '@/modules/Analytics/routes.js';
import { profileHistory, myProfile } from '@/modules/Profile/routes.js';
import { tools, settings } from '@/modules/Settings/routes.js';
import { giftedChildren } from '@/modules/GiftedChilds/routes.js';
import { eventModerationList } from '@/modules/Moderation/routes.js';
import { mailing } from '@/modules/Mailing/routes.js';
import { documents } from '@/modules/Documents/routes.js';
import { personal } from '@/modules/Personal/routes.js';
import {
  userLogin,
  userRecovery,
  allDuplicatePage,
  eventsPage,
  eventTemplates,
  adminEventAssociations,
  operatorLogin,
} from '@/modules/Admin/routes.js';
import { partners } from '@/modules/Partners/routes.js';
// import { exhibitions } from '@/modules/EventExhibition/routes';
import { eventCreate, eventsOrganizer } from '@/modules/UIDesign/Events/routes';

import { mapGetters } from 'vuex';
import { uiPersonal } from '@/modules/UIDesign/Personal/routes';

export default {
  computed: {
    ...mapGetters({
      hasEventAssociations: 'auth/hasEventAssociations',
    }),
    navigationParticipant() {
      return [
        defaultMain,
        events,
        // teams,
        profileHistory,
        // myProfile,
      ];
    },
    navigationOrganization() {
      return [
        defaultMain,
        uiEventPlan,
        eventsOrganizer,
        uiEventsStockDashboard,
        eventCreate,
        uiPersonal,
      ];
    },
    navigation() {
      return {
        certificate: this.navigationParticipant,
        member: this.navigationParticipant,
        trainer: [defaultMain, myTeamsList, myTeamsEventsRequests, myProfile],
        organizations: [
          defaultMain,
          // tools,
          eventPlan,
          // exhibitions,
          ...this.hasEventAssociations ? [eventAssociations] : [],
          events,
          eventsStock,
          personal,
          // analytics,
          // myProfile,
        ],
        department: [defaultMain, eventModerationList, eventPlan, analytics, settings, giftedChildren],
        operators: [defaultMain, events, eventPlan, documents, giftedChildren, analytics, settings, mailing],
        admins: [defaultMain, userLogin, userRecovery, allDuplicatePage, eventsPage, eventTemplates, adminEventAssociations, operatorLogin],
        expert: [
          defaultMain,
          events,
          partners,
          // myProfile,
        ],
        moderator: [eventModerationList],
        event_manager: [defaultMain, events, personal],
      };
    },
  },
};
